import { Button, Flex, KeyboardArrowDownRoundedIcon, Text } from '@shared/components';
import { useState } from 'react';

import {
  ImportExamineeErrorCard,
  type ImportExamineeErrorCardProps,
} from '../import-examinee-error-card/';

export interface ImportWrIncompleteListProps {
  errors: ImportExamineeErrorCardProps[];
  pageSize?: number;
}

const DEFAULT_PAGE_SIZE = 20;

export default function ImportWrIncompleteList(props: Readonly<ImportWrIncompleteListProps>) {
  const { errors, pageSize = DEFAULT_PAGE_SIZE } = props;
  const [visibleCount, setVisibleCount] = useState(Math.min(pageSize, errors.length));

  const hasMore = visibleCount < errors.length;

  const handleShowMore = () => {
    setVisibleCount((count) => Math.min(count + pageSize, errors.length));
  };

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(2), width: '100%' })}>
      <Text variant='body1Semibold'>
        รายชื่อที่นำเข้าหรือแก้ไขข้อมูลไม่สำเร็จ ({errors.length} คน):
      </Text>
      {errors.slice(0, visibleCount).map((error, index) => (
        <ImportExamineeErrorCard key={`${error.title}-${index}`} {...error} />
      ))}
      {hasMore ? (
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            alignItems: 'center',
            gap: theme.spacing(2),
            width: '100%',
          })}
        >
          <Button
            variant='outlined'
            color='secondary'
            size='small'
            endIcon={<KeyboardArrowDownRoundedIcon fontSize='small' />}
            onClick={handleShowMore}
          >
            ดูเพิ่มเติม
          </Button>
          <Text variant='caption' color='secondary'>
            แสดง {visibleCount} จาก {errors.length}
          </Text>
        </Flex>
      ) : null}
    </Flex>
  );
}
